import { __ } from "@wordpress/i18n";
import apiFetch from "@wordpress/api-fetch";
import { REST_URL } from "@/utils/constants";

export type RestApiResponse<T> = {
    success: true;
    data: T;
} | {
    success: false;
    message: string;
};

export const api = {
    request: async <T>(path: string, method: string, body?: any) =>
        apiFetch<RestApiResponse<T>>({
            url: REST_URL + path,
            method,
            headers: body instanceof FormData ? {} : { "Content-Type": "application/json" },
            body: body instanceof FormData ? body : JSON.stringify(body),
        }).then((data: RestApiResponse<T>) => {
            if (!data.success) throw { message: data.message || __("Something went wrong", "antimanual") };
            return data.data;
        }),
    get: async function <T>(path: string) {
        return this.request<T>(path, "GET");
    },
    post: async function <T>(path: string, body: FormData | Record<string, any>) {
        return this.request<T>(path, "POST", body);
    },
    put: async function <T>(path: string, body: FormData | Record<string, any>) {
        return this.request<T>(path, "PUT", body);
    },
    delete: async function <T>(path: string) {
        return this.request<T>(path, "DELETE");
    },
};
